import cn from 'classnames'
import Image from 'next/image'
import { useDefaultLogo } from 'src/hooks/useDefaultLogo'

interface VendorLogoProps {
  src?: string | null
  className?: string
}

const VendorLogo: React.FC<VendorLogoProps> = ({ src, className }) => {
  const source = useDefaultLogo(src)
  return <Image className={cn(`${className}`)} src={source} alt="" width={1000} height={1000} priority />
}

export default VendorLogo
